import { z } from 'zod';
import { ulidSchema } from './id';

export const emailToCardAddressViewSchema = z.strictObject({
  cardId: ulidSchema,
  userId: ulidSchema,
  address: z.string().email(),
  active: z.boolean(),
});
export type EmailToCardAddressView = z.infer<typeof emailToCardAddressViewSchema>;
